import React from 'react'

const LanguageSelector = ({ langs, selectedLang, collapsed, onLanguageChange }) => {
    return (
        <div className="lang-changer-group mt-1 xl3:mt-6 border p-2 pointer font-bold text-lg border-mudPurple text-[#9392AD] rounded-full flex flex-row w-fit">
            {langs?.map((lang) => {
                if (collapsed && lang.code === selectedLang) {
                    return (
                        <p className={`lang-item mx-2 ${lang.code === selectedLang ? 'text-white' : ''}`} key={lang.code}>
                            {lang.name}
                        </p>
                    )
                } else if (!collapsed) {
                    return (
                        <button
                            className={`lang-item mx-2 ${lang.code === selectedLang ? 'text-white' : ''}`}
                            key={lang.code}
                            disabled={lang.code === selectedLang}
                            onClick={(e) => {
                                e.preventDefault()
                                onLanguageChange(lang.code)
                            }}
                        >
                            {lang.name}
                        </button>
                    )
                }
                return null
            })}
        </div>
    )
}

export default LanguageSelector
